export const load = (key: string) => {
  return JSON.parse(localStorage.getItem(key))
}

export const set = (key: string, data: any, auth: any = null) => {
  localStorage.setItem(key, JSON.stringify({timestamp: new Date(), user: auth ? auth.user.id : null, payload: data}))
}